import React from 'react'
import { Card, CardMedia, CardContent, Box, Paper, Typography, Grid, Stack, Divider, Avatar, CardHeader, TableContainer, Table, TableHead, TableRow, TableCell, styled, Fade, TableBody, tooltipClasses, tableCellClasses, Tooltip, Button, FormControl, DialogTitle, IconButton, DialogContent, Snackbar, Alert, InputBase, InputLabel, Dialog, DialogActions, Slide, alpha, TextField, OutlinedInput, Container, useMediaQuery, useTheme } from '@mui/material'
import banner22 from '../assests/bed2.jpg';
import DateTimeCard from '../components/Cards/DateTimeCard';
import { CalendarMonth, CameraAlt, House, BusinessCenter, Assignment, AccountBalance, CalendarMonthOutlined, Check, Send, Close } from '@mui/icons-material';
import { red } from '@mui/material/colors';
import topCorner from '../assests/topcorner.png'
import bottomCorner from '../assests/bottomcorner.png'
import selected from '../assests/Icons/selected.png'
import { DatePicker, DateTimeField, DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const CustomBanner = styled(Paper)(({ theme }) => ({
    background: ` linear-gradient(
        rgb(197 192 192 / 7%), 
        rgb(0 0 0 / 28%)
      ),url(${banner22})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'norepeat',
    backgroundPosition: 'cover',
    overflow: 'hidden',
    // padding: 40,
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    alignItems: 'start',
    height: '100%',
    borderRadius: 0,
    marginTop: '3em'
}))

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: '#242646',
    },
    [`& .${tooltipClasses.tooltip}`]: {
        width: '200px',
        backgroundColor: '#242646',
        color: '#fff',
        textAlign: 'center',
        borderRadius: '6px',
        padding: '5px 10px',
        fontWeight: 400,
        fontSize: '13px',
        transition: '0.15s visibility',
        lineHeight: '1.3em',
    },
}));

const StyledImg = styled('img')(({ theme }) => ({
    width: '25px',
    height: '25px',
    display: 'block',
    margin: '0 auto',
    borderRadius: '60px',
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.common.grey,
    },
    [`&.${tableCellClasses.body}`]: {
        alignItems: 'center',
        borderRight: '1px solid #e9e9e9'
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    backgroundColor: '#fafafa',
}));

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(1),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));


const BootstrapInput = styled(InputBase)(({ theme, Matches }) => ({
    width: Matches ? '280px' : '450px',
    'label + &': {
        marginTop: theme.spacing(3),
        color: '#000'
    },
    '& .MuiInputBase-input': {
        borderRadius: 4,
        position: 'relative',
        textAlign: 'start',
        backgroundColor: theme.palette.mode === 'light' ? '#F4F3F2' : '#1A2027',
        border: '1px solid',
        borderColor: theme.palette.mode === 'light' ? '#F4F3F2' : '#2D3843',
        fontSize: 16,
        width: '100%',
        padding: '5px 12px',
        transition: theme.transitions.create([
            'border-color',
            'background-color',
            'box-shadow',
        ]),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
        },
    },
}));

const BootstrapInput1 = styled(DateTimePicker)(({ theme, Matches }) => ({
    width: Matches ? '250px' : '450px',
    borderRadius: 4,
    position: 'relative',
    textAlign: 'start',
    backgroundColor: theme.palette.mode === 'light' ? '#F4F3F2' : '#1A2027',
    border: '1px solid',
    borderColor: theme.palette.mode === 'light' ? '#F4F3F2' : '#2D3843',
    fontSize: 16,
    width: '92%',
    padding: '5px 8px',
    transition: theme.transitions.create([
        'border-color',
        'background-color',
        'box-shadow',
    ]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
        boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
        borderColor: theme.palette.primary.main,
    },
    'label + &': {
        marginTop: theme.spacing(3),
        color: '#000'
    },
    '& .MuiOutlinedInput-root': {
        border: 'none', // Remove the border of the input
    },
    '& .MuiInputBase-input': {
        borderRadius: 4,
        position: 'relative',
        textAlign: 'start',
        fontSize: 16,
        width: '100%',
        padding: '5px',
        transition: theme.transitions.create([
            'border-color',
            'background-color',
            'box-shadow',
        ]),
    },
    '& .MuiInputLabel-root': {
        display: 'none', // Hide the label
    },
    '& .MuiOutlinedInput-notchedOutline': {
        border: 'none', // Remove the outline border
    },
    '& .MuiInputAdornment-root': {
        width: '30px',
        height: '30px' // Hide adornments if any
    },
}));


const StyledInput = styled(InputLabel)({
    fontSize: '20px',
    color: '#000',
    fontWeight: 500
});

const iconsArray = [
    {
        icon: <CalendarMonthOutlined />,
        title: 'Book your free Listing Consultation',
        description: 'Your Pricing Agent will meet you at your home to design a pricing strategy that fits your needs.'
    },
    {
        icon: <CameraAlt />,
        title: 'Photoshoot',
        description: 'Real Prop`s professional photographers know all the angles to make your home shine.'
    },
    {
        icon: <House />,
        title: 'On the Market',
        description: 'From MLS listing to digital marketing to open houses, your agent and their team will get your home the exposure it deserves'
    },
    {
        icon: <BusinessCenter />,
        title: 'Negotiate a Deal',
        description: 'Your Listing Agent will watch the market and guide you through negotiation with buyers, getting you the best possible deal.'
    },
    {
        icon: <Assignment />,
        title: 'We Handle the Paperwork',
        description: 'Your agent has the experience to guide you through inspection, appraisal, and the title process to a successful closing. '
    },
    {
        icon: <AccountBalance />,
        title: 'Close and Save',
        description: 'You`ll take home an extra $12,000 in proceeds on average! You don`t pay anything until you close.'
    }
];

function createData(
    name: string,
    calories: string,
    fat: string,
    carbs: number,
    protein: number,
) {
    return { name, calories, fat, };
}

const rows1 = [
    createData('Home Valuation', <Avatar sx={{ bgcolor: '#978A7D', width: '25px', height: '25px' }} aria-label="recipe"><Check fontSize='small' /></Avatar>),
    createData('Listed on Zillow & MLS', <Avatar sx={{ bgcolor: '#978A7D', width: '25px', height: '25px' }} aria-label="recipe"><Check fontSize='small' /></Avatar>),
    createData('Multiple Cash Offers', <Avatar sx={{ bgcolor: '#978A7D', width: '25px', height: '25px' }} aria-label="recipe"><Check fontSize='small' /></Avatar>),
    createData('Professional Photography', <Avatar sx={{ bgcolor: '#978A7D', width: '25px', height: '25px' }} aria-label="recipe"><Check fontSize='small' /></Avatar>),
    createData('Yard Signage', <Avatar sx={{ bgcolor: '#978A7D', width: '25px', height: '25px' }} aria-label="recipe"><Check fontSize='small' /></Avatar>),
    createData('In-Person Consultation', <Avatar sx={{ bgcolor: '#978A7D', width: '25px', height: '25px' }} aria-label="recipe"><Check fontSize='small' /></Avatar>),
    createData('Agent Hosted Open House', <Avatar sx={{ bgcolor: '#978A7D', width: '25px', height: '25px' }} aria-label="recipe"><Check fontSize='small' /></Avatar>),
    createData('Social Media Marketing', <Avatar sx={{ bgcolor: '#978A7D', width: '25px', height: '25px' }} aria-label="recipe"><Check fontSize='small' /></Avatar>),
    createData('3D Home Tours', <Avatar sx={{ bgcolor: '#978A7D', width: '25px', height: '25px' }} aria-label="recipe"><Check fontSize='small' /></Avatar>),
    createData('Professional Marketing', <Avatar sx={{ bgcolor: '#978A7D', width: '25px', height: '25px' }} aria-label="recipe"><Check fontSize='small' /></Avatar>),
];



function SpealDailog(props) {
    const [formData, setFormData] = React.useState({
        date: dayjs(),
        name: '',
        email: '',
        phone: '',
        message: '',
    });
    const [errors, setErrors] = React.useState({});
    const [openError, setOpenError] = React.useState(false);
    // const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [isSuccess, setIsSuccess] = React.useState(true);
    const [state, setState] = React.useState({
        open: false,
        vertical: 'top',
        horizontal: 'center',
    });

    const { vertical, horizontal, open, } = state;

    const handleSnackbarOpen = (newState) => () => {
        setState({ open: true, ...newState });
    };

    const formatDateToWords = (date) => {
        return date ? dayjs(date).format('dddd, MMMM D, YYYY h:mm A') : '';
    };
    // const handleSnackbarClose = (event, reason) => {
    //     if (reason === 'clickaway') {
    //         return;
    //     }
    //     setState({ ...state, open: false });
    // };

    const handleClickError = () => {
        setOpenError(true);
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const handlePhoneInputChange = (e) => {
        const value = e.target.value.replace(/\D/g, ''); // Allow only digits
        setFormData((prevData) => ({
            ...prevData,
            phone: value,
        }));
    };




    const validateFormData = () => {
        const { date, name, email, phone, message } = formData;

        if (!date || !name || !email || !phone || !message) {
            // At least one field is empty
            return false;
        }

        // Your other validation logic here

        return true;
    };

    const handleSnackbarClose = () => {
        setState({ open: false });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const isFormValid = validateFormData();

        if (isFormValid) {
            // No errors, proceed with form submission
            setIsSuccess(true);
            setState({ open: true, vertical: 'bottom', horizontal: 'right' });
            setFormData({
                date: dayjs(),
                name: '',
                email: '',
                phone: '',
                message: '',
            });
            console.log('DATA', formatDateToWords(formData.date.format('MM/DD/YYYY, h:mm A')));
        } else {
            // Error in form submission
            setIsSuccess(false);
            setState({ open: true, vertical: 'bottom', horizontal: 'right' });
        }

        // Open the Snackbar

    };

    return (
        <BootstrapDialog
            aria-labelledby="customized-dialog-title"
            open={props.open}
            TransitionComponent={Transition}
            sx={{ width: '100%' }}
        >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                Contact our Team
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={props.close}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <Close />
            </IconButton>
            <DialogContent dividers>
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2} sx={{ p: props.Matches ? 0 : '1em 3em' }}>
                        <Grid item xs={12}>
                            <FormControl variant="standard" fullWidth sx={{ ml: '10px' }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <StyledInput shrink htmlFor="bootstrap-input" >Select Date and Time</StyledInput>
                                    <BootstrapInput1
                                        name="date"
                                        value={formData.date}
                                        onChange={(newValue) => handleInputChange({ target: { name: 'date', value: newValue } })}
                                        slotProps={{ field: { shouldRespectLeadingZeros: true } }}
                                        Matches={props.Matches}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl variant="standard">
                                <StyledInput shrink htmlFor="bootstrap-input" >Name</StyledInput>
                                <BootstrapInput
                                    label="Name"
                                    fullWidth
                                    name="name"
                                    type="text"
                                    required
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    size="small"
                                    error={!!errors.name}
                                    helperText={errors.name}
                                    Matches={props.Matches}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl variant="standard">
                                <StyledInput shrink htmlFor="bootstrap-input" >Email</StyledInput>
                                <BootstrapInput
                                    label="Email"
                                    fullWidth
                                    type="email"
                                    name="email"
                                    required
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    Matches={props.Matches}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl variant="standard">
                                <StyledInput shrink htmlFor="bootstrap-input" >Phone Number</StyledInput>
                                <BootstrapInput
                                    label="Phone"
                                    fullWidth
                                    name="phone"
                                    required
                                    value={formData.phone}
                                    onChange={handlePhoneInputChange}
                                    Matches={props.Matches}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl variant="standard">
                                <StyledInput shrink htmlFor="bootstrap-input" >Message</StyledInput>
                                <BootstrapInput
                                    fullWidth
                                    multiline
                                    rows={4}
                                    name="message"
                                    required
                                    value={formData.message}
                                    onChange={handleInputChange}
                                    Matches={props.Matches}
                                />
                            </FormControl>

                        </Grid>
                    </Grid>
                    <DialogActions>
                        <Button sx={{
                            mr: '2em',
                            color: '#fff',
                            background: '#978A7D',
                            textTransform: 'capitalize'
                        }}
                            type="submit"
                            endIcon={<Send />}
                        >Send</Button>
                        <Snackbar
                            open={open}
                            autoHideDuration={4000}
                            onClose={handleSnackbarClose}
                        >
                            <Alert
                                onClose={handleSnackbarClose}
                                severity={isSuccess ? 'success' : 'error'}
                                variant="filled"
                            >
                                {isSuccess
                                    ? 'Form submitted successfully!'
                                    : 'Please fill in all fields.'}
                            </Alert>
                        </Snackbar>
                    </DialogActions>
                </form>
            </DialogContent>
        </BootstrapDialog>
    )

}

export const Sell = () => {
    const [open, setOpen] = React.useState(false);
    const [open1, setOpen1] = React.useState(false);
    const matches = useMediaQuery('(max-width:600px)');
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleClickOpen1 = () => {
        setOpen1(true);
    };

    const handleClose1 = () => {
        setOpen1(false);
    };

    return (
        <div>
            <Paper elevation={0} sx={{ mt: '4em' }} >
                <CustomBanner elevation={0}>
                    <Box sx={{
                        m: matches ? '5em 1em' : '5em', display: 'flex', flexDirection: 'column', justifyContent: 'center',
                    }}>
                        <Stack spacing={1} display="flex" justifyContent="center" alignItems="center" sx={{
                            p: matches ? '10px' : '3em 5em',
                            bgcolor: '#ffffff9e',
                            borderRadius: '10px',
                        }}>
                            <Typography variant='h4' gutterBottom textAlign={matches ? "center" : "start"}
                                sx={{
                                    fontSize: matches ? '22px' : null,
                                    fontWeight: matches ? 600 : null,
                                    letterSpacing: '-0.03em',
                                }}
                            >
                                Make more money selling your home
                            </Typography>
                            <Typography variant="h5" gutterBottom textAlign={matches ? "center" : "start"}
                                sx={{
                                    fontSize: matches ? '16px' : null,
                                    fontWeight: matches ? 500 : null,
                                    letterSpacing: '-0.03em',
                                }}
                            >
                                Sellers get better service and save an average of $12,000 in commissions with Real Prop.
                            </Typography>
                            {matches ?
                                <>
                                    <Button
                                        onClick={handleClickOpen1}
                                        sx={{
                                            mt: '1em',
                                            fontSize: '15px',
                                            fontWeight: 500,
                                            width: '250px',
                                            background: '#978A7D',
                                            color: '#fff',
                                            borderRadius: '20px',
                                            textTransform: 'capitalize',
                                            '&:hover': {
                                                backgroundColor: '#444444',
                                                color: '#fff',
                                            },
                                            '&:disabled': {
                                                backgroundColor: '#d3d3d3', // Change this to your desired disabled color
                                                color: '#9e9e9e', // Change this to your desired disabled text color
                                            },
                                        }}>
                                        Schedule a Free Consultation
                                    </Button>
                                    <BootstrapDialog
                                        fullScreen
                                        aria-labelledby="customized-dialog-title"
                                        open={open1}
                                        TransitionComponent={Transition}
                                        fullWidth={fullScreen}
                                    >
                                        <IconButton
                                            aria-label="close"
                                            onClick={handleClose1}
                                            sx={{
                                                position: 'absolute',
                                                right: 8,
                                                top: 23,
                                                color: (theme) => theme.palette.grey[500],
                                            }}
                                        >
                                            <Close />
                                        </IconButton>
                                        <DateTimeCard close={setOpen1}/>
                                    </BootstrapDialog>
                                </>
                                :
                                <DateTimeCard />}
                        </Stack>
                    </Box>
                </CustomBanner>
                {/* <Grid container spacing={2} sx={{ background: '#EFE8E5' }}>
                    <Grid item xs={6}>
                        <Box maxWidth='xl' sx={{ display: 'flex', flexDirection: 'column', width: '100%', justifyContent: 'center', alignItems: 'start', p: '7em 5em 5em 5em' }}>
                            <Stack sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start', width: '100%' }}>
                                <Typography variant='h4' gutterBottom textAlign="start">
                                    Make more money selling your home
                                </Typography>
                                <Typography variant="h5" gutterBottom textAlign="start">
                                    Sellers get better service and save an average of $12,000 in commissions with Real Prop.
                                </Typography>
                                <DateTimeCard />
                            </Stack>
                        </Box>
                    </Grid>
                    <Grid item xs={6}>
                        <Card sx={{ display: 'flex', justifyContent: 'end', alignItems: 'end', borderRadius: 0, background: '#fff', }} elevation={0}>
                            <CardMedia
                                component="img"
                                sx={{ height: '112ch', width: '100%' }}
                                image={`${banner22}`}
                                title="green iguana"
                            />
                        </Card>
                    </Grid>
                </Grid> */}
                <Divider />
                <Container maxWidth="xl">
                    <Grid container spacing={1} sx={{ p: matches ? '2em 1em' : '2em 12em 5em 12em' }} display="flex" justifyContent="center">

                        <Grid item xs={matches ? 12 : 11.5} gutterBottom>
                            <Typography variant="h4" sx={{
                                textAlign: 'center',
                                fontSize: matches ? '22px' : null,
                                fontWeight: matches ? 600 : null,
                                letterSpacing: '-0.03em',
                            }}>
                                Selling your home has never been easier
                            </Typography>
                        </Grid>
                        {
                            iconsArray.map((item) => {
                                return (
                                    <Grid item xs={matches ? 12 : 4} display="flex" justifyContent="center" sx={{ mt: matches ? '1em' : '2em', }}>
                                        <Card
                                            variant="outlined"
                                            sx={{
                                                width: matches ? 'auto' : '90%',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <Grid container spacing={1} sx={{ p: '2em 1em 0em 1em' }}>
                                                <Grid item xs={2}>
                                                    <Avatar sx={{ bgcolor: '#978A7D', marginRight: 2 }} aria-label="recipe">
                                                        {item.icon}
                                                    </Avatar>
                                                </Grid>
                                                <Grid item xs={8} display="flex" justifyContent="start" alignItems="center">
                                                    <Typography variant="h6" component="div" sx={{ textAlign: 'start', fontWeight: 600, lineHeight: 1.3 }}>
                                                        {item.title}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12} sx={{ p: '1em 0em 2em 4em' }}>
                                                    <Typography variant="body2" component="div" sx={{ textAlign: 'start' }}>
                                                        {item.description}
                                                    </Typography>
                                                </Grid >
                                            </Grid>


                                        </Card>
                                    </Grid>
                                )
                            })
                        }

                    </Grid>
                </Container>
                <Paper elevation={0} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', bgcolor: '#fafafa' }}>
                    <Divider />
                    <Container maxWidth="xl">
                        {
                            matches ?
                                <Grid container spacing={2} sx={{ p: '2em 1em', display: 'flex', flexDirection: 'column', justifyContent: 'center', }}>
                                    <Grid item xs={12} display='flex' justifyContent="end" alignItems="end">
                                        <img src={topCorner} alt="img" width={matches ? "150px" : "250px"} height={matches ? "150px" : "250px"}
                                            style={{
                                                display: 'block',
                                                right: '2%',

                                            }} />
                                    </Grid>
                                    <Grid item xs={12} display='flex' flexDirection="column" justifyContent="center" alignItems="center">
                                        <Typography variant='h4' gutterBottom sx={{
                                            textAlign: 'start',
                                            textAlign: 'center',
                                            fontSize: matches ? '22px' : null,
                                            fontWeight: matches ? 600 : null,
                                            letterSpacing: '-0.03em',
                                        }}>
                                            Save up to 50% selling with us
                                        </Typography>
                                        <Typography variant="h7" gutterBottom textAlign={matches ? "center" : "start"}
                                            sx={{
                                                fontSize: matches ? '16px' : null,
                                                fontWeight: matches ? 500 : null,
                                                letterSpacing: '-0.03em',
                                            }}>
                                            We charge 1% to list your home and we recommend a 2-3% buyer broker commission. That means you can save as much as 50% from a traditional 6% commission.
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} display='flex' flexDirection={matches ? 'row' : 'row'} justifyContent="center" alignItems={matches ? "center" : "start"}>
                                        <TableContainer component={Paper} elevation={0} sx={{ borderRadius: '0px' }}>
                                            <Table sx={{ minWidth: 'auto', }} stickyHeader aria-label="sticky table">
                                                <TableHead sx={{ backgroundColor: '#fafafa', }}>
                                                    <TableRow sx={{ backgroundColor: '#fafafa', display: 'none', }}>
                                                        <TableCell align="center" sx={{
                                                            backgroundColor: '#fafafa',
                                                            color: '#000',
                                                        }}></TableCell>
                                                        <TableCell align="center" sx={{
                                                            backgroundColor: '#fafafa',
                                                            color: '#000',
                                                            fontWeight: '500 ',
                                                        }}></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody sx={{ borderTop: '1px solid #e9e9e9' }}>
                                                    <StyledTableRow >
                                                        <StyledTableCell component="th" scope="row" sx={{
                                                            fontSize: '15px',
                                                            minWidth: 'auto',
                                                            width: matches ? 'auto' : '250px',
                                                            padding: matches ? '8px' : '15px 10px 15px 15px',
                                                            letterSpacing: '-0.015em',
                                                            fontWeight: 600,
                                                            borderLeft: '1px solid #e9e9e9',
                                                            borderTop: '1px solid #e9e9e9',
                                                        }}>
                                                            Your Agent
                                                        </StyledTableCell>
                                                        <StyledTableCell component="th" align="center" sx={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            fontSize: '15px',
                                                            minWidth: 'auto',
                                                            width: 'auto',
                                                            letterSpacing: '-0.015em',
                                                            fontWeight: 400,
                                                            borderTop: '1px solid #e9e9e9',
                                                        }}>Inperson</StyledTableCell>
                                                    </StyledTableRow>
                                                    {rows1.map((row) => (
                                                        <StyledTableRow key={row.name}>
                                                            {
                                                                (row.name) === '' ? null :
                                                                    <>
                                                                        <StyledTableCell component="th" scope="row" sx={{
                                                                            fontSize: '15px',
                                                                            minWidth: '155px',
                                                                            width: matches ? '150px' : '250px',
                                                                            padding: matches ? '8px' : '15px 10px 15px 15px',
                                                                            letterSpacing: '-0.015em',
                                                                            fontWeight: 600,
                                                                            borderLeft: '1px solid #e9e9e9',
                                                                        }}>
                                                                            {row.name}
                                                                        </StyledTableCell>
                                                                        <StyledTableCell align="center" sx={{
                                                                            display: 'flex',
                                                                            justifyContent: 'center',
                                                                            fontSize: '15px',
                                                                            letterSpacing: '-0.015em',
                                                                            fontWeight: 400,
                                                                        }}>{row.calories}</StyledTableCell>
                                                                    </>
                                                            }

                                                        </StyledTableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                    <Grid item xs={12} display='flex' justifyContent="start" alignItems="start">
                                        <img src={bottomCorner} alt="img" width={matches ? "150px" : "250px"} height={matches ? "150px" : "250px"}
                                            style={{
                                                display: 'block',
                                                left: '2%',
                                                transform: 'rotate(180deg)',
                                            }} />
                                    </Grid>
                                </Grid>
                                :
                                <Grid container spacing={2} sx={{ p: matches ? '2em 1em' : '3em 6em', }}>
                                    <Grid item xs={1} display='flex' justifyContent="end" alignItems="end">
                                        <img src={bottomCorner} alt="img" width={matches ? "150px" : "250px"} height={matches ? "150px" : "250px"}
                                            style={{
                                                display: 'block',
                                                position: 'absolute',
                                                left: '2%',
                                                transform: 'rotate(180deg)',
                                            }} />
                                    </Grid>
                                    <Grid item xs={10} display='flex' flexDirection={matches ? 'row' : 'row'} justifyContent="center" alignItems={matches ? "center" : "start"} >
                                        <Stack display="flex" justifyContent={matches ? "center" : "start"} alignItems="start" flexDirection={matches ? 'column' : 'row'} sx={{ p: '8em 2em' }}>
                                            <Stack display="flex" justifyContent={matches ? "center" : "start"} alignItems="center" sx={{ width: matches ? 'auto' : '50%' }}>
                                                <Typography variant='h4' gutterBottom sx={{
                                                    textAlign: 'start',
                                                    textAlign: 'center',
                                                    fontSize: matches ? '22px' : null,
                                                    fontWeight: matches ? 600 : null,
                                                    letterSpacing: '-0.03em',
                                                }}>
                                                    Save up to 50% selling with us
                                                </Typography>
                                                <Typography variant="h7" gutterBottom textAlign={matches ? "center" : "start"}
                                                    sx={{
                                                        fontSize: matches ? '16px' : null,
                                                        fontWeight: matches ? 500 : null,
                                                        letterSpacing: '-0.03em',
                                                    }}>
                                                    We charge 1% to list your home and we recommend a 2-3% buyer broker commission. That means you can save as much as 50% from a traditional 6% commission.
                                                </Typography>
                                            </Stack>
                                            <Stack display="flex" justifyContent="start" alignItems="center" sx={{ width: '50%', }}>
                                                <TableContainer component={Paper} elevation={0} sx={{ borderRadius: '0px', ml: '3em', m: matches ? '1em 0 2em 0' : null }}>
                                                    <Table sx={{ minWidth: matches ? 'auto' : '100%', }} stickyHeader aria-label="sticky table">
                                                        <TableHead sx={{ backgroundColor: '#fafafa', }}>
                                                            <TableRow sx={{ backgroundColor: '#fafafa', display: 'none', }}>
                                                                <TableCell align="center" sx={{
                                                                    backgroundColor: '#fafafa',
                                                                    color: '#000',
                                                                }}></TableCell>
                                                                <TableCell align="center" sx={{
                                                                    backgroundColor: '#fafafa',
                                                                    color: '#000',
                                                                    fontWeight: '500 ',
                                                                }}></TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody sx={{ borderTop: '1px solid #e9e9e9' }}>
                                                            <StyledTableRow >
                                                                <StyledTableCell component="th" scope="row" sx={{
                                                                    fontSize: '15px',
                                                                    minWidth: matches ? '155px' : null,
                                                                    width: matches ? '150px' : '250px',
                                                                    padding: matches ? '8px' : '15px 10px 15px 15px',
                                                                    letterSpacing: '-0.015em',
                                                                    fontWeight: 600,
                                                                    borderLeft: '1px solid #e9e9e9',
                                                                    borderTop: '1px solid #e9e9e9',
                                                                }}>
                                                                    Your Agent
                                                                </StyledTableCell>
                                                                <StyledTableCell align="center" sx={{
                                                                    display: 'flex',
                                                                    justifyContent: 'center',
                                                                    fontSize: '15px',
                                                                    width: '250px',
                                                                    letterSpacing: '-0.015em',
                                                                    fontWeight: 400,
                                                                    borderTop: '1px solid #e9e9e9',
                                                                }}>Inperson</StyledTableCell>
                                                            </StyledTableRow>
                                                            {rows1.map((row) => (
                                                                <StyledTableRow key={row.name}>
                                                                    {
                                                                        (row.name) === '' ? null :
                                                                            <>
                                                                                <StyledTableCell component="th" scope="row" sx={{
                                                                                    fontSize: '15px',
                                                                                    width: matches ? '150px' : '250px',
                                                                                    padding: matches ? '8px' : '15px 10px 15px 15px',
                                                                                    letterSpacing: '-0.015em',
                                                                                    fontWeight: 600,
                                                                                    borderLeft: '1px solid #e9e9e9',
                                                                                }}>
                                                                                    {row.name}
                                                                                </StyledTableCell>
                                                                                <StyledTableCell align="center" sx={{
                                                                                    display: 'flex',
                                                                                    justifyContent: 'center',
                                                                                    fontSize: '15px',
                                                                                    width: '250px',
                                                                                    letterSpacing: '-0.015em',
                                                                                    fontWeight: 400,
                                                                                }}>{row.calories}</StyledTableCell>
                                                                            </>
                                                                    }

                                                                </StyledTableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Stack>
                                        </Stack>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <img src={topCorner} alt="img" width={matches ? "150px" : "250px"} height={matches ? "150px" : "250px"}
                                            style={{
                                                display: 'block',
                                                position: 'absolute',
                                                right: '2%',

                                            }} />
                                    </Grid>
                                </Grid>
                        }
                    </Container>
                </Paper>
                <Paper elevation={0} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', p: matches ? '2em 1em' : '5em 10em' }}>
                    <Container maxWidth="lg" sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }}>
                        <Card elevation={3} sx={{ background: '#EFE8E5', color: '#fff', borderRadius: '15px', p: matches ? '2em 1em' : '5em', width: matches ? 'auto' : '750px' }}>
                            <Stack display="flex" justifyContent="center" alignItems="center">
                                <Typography variant="h4"
                                    sx={{
                                        textAlign: 'start',
                                        textAlign: 'center',
                                        fontSize: matches ? '22px' : null,
                                        fontWeight: matches ? 600 : null,
                                        letterSpacing: '-0.03em',
                                    }}>Book your free, no-obligation valuation now!</Typography>
                                <Typography variant="h6"
                                    sx={{
                                        fontSize: matches ? '16px' : null,
                                        mt: matches ? '1em' : null,
                                        fontWeight: matches ? 500 : null,
                                        letterSpacing: '-0.03em',
                                    }}
                                >Your Real Prop Pricing Agent has unparalleled market insight from pricing hundreds of homes per year. Book your free valuation today to find out what your home is really worth — and how much more you’ll take home by working with Real Prop.</Typography>
                                <Button
                                    onClick={handleClickOpen}
                                    sx={{
                                        mt: '1em',
                                        fontSize: '16px',
                                        fontWeight: 500,
                                        width: '250px',
                                        background: '#978A7D',
                                        color: '#fff',
                                        borderRadius: '20px',
                                        textTransform: 'capitalize',
                                        '&:hover': {
                                            backgroundColor: '#444444',
                                            color: '#fff',
                                        },
                                        '&:disabled': {
                                            backgroundColor: '#d3d3d3', // Change this to your desired disabled color
                                            color: '#9e9e9e', // Change this to your desired disabled text color
                                        },
                                    }}>
                                    Schedule a Free Valuation
                                </Button>
                                <SpealDailog open={open} close={handleClose} Matches={matches} />
                            </Stack>

                        </Card>
                    </Container>
                </Paper>
            </Paper>

        </div>
    )
}
